import React, { useState, useEffect } from 'react';
import { Dropdown } from 'telstra-ui/components/drop-down/Dropdown';
import { Checkbox } from 'telstra-ui/components/checkbox/Checkbox';
import { Button } from 'telstra-ui/components/button/Button';
import { Tag } from 'telstra-ui/components/tag/Tag';
import { prepareDropDownOptionsArry } from '../../amp-homepage.actions';

const DeviceFilters = (props) => {
  const {
    authorableContent: {
      filterHeading,
      filterCurrentDeviceText,
      filterCurrentDeviceBelowText,
      filterNewDeviceText,
      filterNewDeviceBelowText,
      filterServiceHeading,
      filterMROHeading,
      filter5G,
      filterNon5G,
      filterMRO,
      filterTradeInHeading,
      filterTradeInEligible,
      filterTradeEligible,
      filterApply,
      filterCancel,
      formFields: {
        tradeIphoneDropDown,
      },
    },
    applyFilter,
    cancelFilter,
    filterOpen,
    filterApplied,
    currentDevicesList,
    filterClearAll,
  } = props;

  const [currentDeviceSearch, setCurrentDeviceSearch] = useState([]); // eslint-disable-line
  const [currentDeviceSearchSelected, setCurrentDeviceSearchSelected] = useState([]);

  const [newDeviceSearch, setNewDeviceSearch] = useState([]);
  const [newDeviceSearchSelected, setNewDeviceSearchSelected] = useState([]);

  const [fiveGCheck, setFiveGCheck] = useState(false);
  const [nonFiveGCheck, setNonFiveGCheck] = useState(false);
  const [mroCheck, setMroCheck] = useState(false);

  const [eligibleCheck, setEligibleCheck] = useState(false);
  const [notEligibleCheck, setNotEligibleCheck] = useState(false);

  const tradeIphoneDropDownOptions = prepareDropDownOptionsArry(tradeIphoneDropDown.options.filter(itm => itm.key !== 'NOSELECTION'));

  useEffect(() => {
    setCurrentDeviceSearch(currentDevicesList);
    setNewDeviceSearch(tradeIphoneDropDownOptions);
  }, [tradeIphoneDropDown.options, currentDevicesList]);

  useEffect(() => {
    if (filterClearAll) {
      setCurrentDeviceSearchSelected([]);
      setNewDeviceSearchSelected([]);
      setFiveGCheck(false);
      setNonFiveGCheck(false);
      setEligibleCheck(false);
      setNotEligibleCheck(false);
      setMroCheck(false);
    }
  }, [filterClearAll]);

  const changeCheckbox = (event) => {
    const checkBoxId = event.target.id;
    const checkedValue = event.target.checked;

    if (checkBoxId === 'filter-5g-checkbox') {
      setFiveGCheck(checkedValue);
      if (checkedValue) {
        setNonFiveGCheck(false);
      }
    } else if (checkBoxId === 'filter-non-5g-checkbox') {
      setNonFiveGCheck(checkedValue);
      if (checkedValue) {
        setFiveGCheck(false);
      }
    } else if (checkBoxId === 'filter-tradein-eligible-checkbox') {
      if (checkedValue) {
        setNotEligibleCheck(false);
      }
      setEligibleCheck(checkedValue);
    } else if (checkBoxId === 'filter-tradein-not-eligible-checkbox') {
      if (checkedValue) {
        setEligibleCheck(false);
      }
      setNotEligibleCheck(checkedValue);
    } else if (checkBoxId === 'filter-mro-checkbox') {
      if (checkedValue) {
        setMroCheck(false);
      }
      setMroCheck(checkedValue);
    }
  };

  const searchPlanBox = (event, dropDownOptions, planSearch) => {
    const searchText = event.target.value.toLowerCase();
    const desiredText = searchText.replace(/[-[\]`~@#%!'=_&";:/.>,<{}()*+?.,\\^$|#]/g);
    const options = dropDownOptions.filter((option) => {
      const optionText = option.displayText.toLowerCase();
      const match = optionText.match(desiredText);
      if (match != null && match.index !== undefined) {
        return true;
      }
      return false;
    });
    planSearch(options);
  };

  const selectCurrentDeviceSearchOption = (event) => {
    const selectedDevice = event.target.getAttribute('data-item');
    const deviceText = currentDevicesList.find(itm => itm.itemId === selectedDevice).displayText;
    if (currentDeviceSearchSelected.includes(deviceText) === false) {
      const selectedDevices = [...currentDeviceSearchSelected, deviceText];
      setCurrentDeviceSearchSelected(selectedDevices);
    }
  };

  const selectNewDeviceSearchOption = (event) => {
    const selectedDevice = event.target.getAttribute('data-item');
    const deviceText = tradeIphoneDropDownOptions.find(itm => itm.itemId === selectedDevice).displayText;
    if (newDeviceSearchSelected.includes(deviceText) === false) {
      const selectedDevices = [...newDeviceSearchSelected, deviceText];
      setNewDeviceSearchSelected(selectedDevices);
    }
  };

  const removeFilterSelectionCurrentDevice = (val) => {
    const currentDevices = currentDeviceSearchSelected.filter(itm => itm !== val);
    setCurrentDeviceSearchSelected(currentDevices);
  };

  const removeFilterSelectionNewDevice = (val) => {
    const currentDevices = newDeviceSearchSelected.filter(itm => itm !== val);
    setNewDeviceSearchSelected(currentDevices);
  };

  const applyFilterSelected = () => {
    const newDevicesKeys = newDeviceSearchSelected.map((itm) => {
      const itmKey = tradeIphoneDropDownOptions.find(item => item.displayText === itm).itemId;
      return itmKey;
    });

    const filterObj = {
      currentDeviceValues: currentDeviceSearchSelected,
      newDeviceValues: newDevicesKeys,
      fiveGCheck,
      nonFiveGCheck,
      eligibleCheck,
      notEligibleCheck,
      mroCheck,
    };
    applyFilter(filterObj);
  };

  const onTagClose = (e) => {
    const idValue = e.target.parentNode.id;
    const [devType, devValue] = idValue.split('|');
    const filterObj = {};

    if (devType === 'currentDevice') {
      const currentDevices = currentDeviceSearchSelected.filter(itm => itm !== devValue);
      setCurrentDeviceSearchSelected(currentDevices);
      filterObj.currentDeviceValues = currentDevices;
    } else {
      filterObj.currentDeviceValues = currentDeviceSearchSelected;
    }
    if (devType === 'newDevice') {
      const newDevicesKeys = newDeviceSearchSelected.map((itm) => {
        const itmKey = tradeIphoneDropDownOptions.find(item => item.displayText === itm).itemId;
        return itmKey;
      });
      const itmKey = tradeIphoneDropDownOptions.find(item => item.displayText === devValue).itemId;
      const newDevices = newDevicesKeys.filter(itm => itm !== itmKey);
      const newDeviceValues = newDeviceSearchSelected.filter(devItm => devItm !== devValue);
      setNewDeviceSearchSelected(newDeviceValues);
      filterObj.newDeviceValues = newDevices;
    } else {
      const newDevicesKeys = newDeviceSearchSelected.map((itm) => {
        const itmKey = tradeIphoneDropDownOptions.find(item => item.displayText === itm).itemId;
        return itmKey;
      });
      filterObj.newDeviceValues = newDevicesKeys;
    }
    if (devType === 'fiveg5G') {
      setFiveGCheck(false);
      filterObj.fiveGCheck = false;
    } else {
      filterObj.fiveGCheck = fiveGCheck;
    }
    if (devType === 'fivegNon5G') {
      setNonFiveGCheck(false);
      filterObj.nonFiveGCheck = false;
    } else {
      filterObj.nonFiveGCheck = nonFiveGCheck;
    }
    if (devType === 'tradeEligible') {
      setEligibleCheck(false);
      filterObj.eligibleCheck = false;
    } else {
      filterObj.eligibleCheck = eligibleCheck;
    }
    if (devType === 'tradeInEligible') {
      setNotEligibleCheck(false);
      filterObj.notEligibleCheck = false;
    } else {
      filterObj.notEligibleCheck = notEligibleCheck;
    }
    if (devType === 'mroCheck') {
      setMroCheck(false);
      filterObj.mroCheck = false;
    } else {
      filterObj.mroCheck = mroCheck;
    }
    if (filterObj.currentDeviceValues.length === 0 &&
      filterObj.newDeviceValues.length === 0 &&
      !filterObj.fiveGCheck &&
      !filterObj.nonFiveGCheck &&
      !filterObj.eligibleCheck &&
      !filterObj.notEligibleCheck &&
      !filterObj.mroCheck
    ) {
      cancelFilter();
    } else {
      applyFilter(filterObj);
    }
  };

  const generateFilterTags = () => {
    let allTags = [];
    const currentDevices = currentDeviceSearchSelected.map(dev => (
      {
        devType: 'currentDevice',
        devValue: dev,
      }
    ));
    allTags = [...currentDevices];

    const newDevices = newDeviceSearchSelected.map(dev => (
      {
        devType: 'newDevice',
        devValue: dev,
      }
    ));

    allTags = [...allTags, ...newDevices];

    if (fiveGCheck) {
      allTags.push({
        devType: 'fiveg5G',
        devValue: filter5G,
      });
    }
    if (nonFiveGCheck) {
      allTags.push({
        devType: 'fivegNon5G',
        devValue: filterNon5G,
      });
    }
    if (eligibleCheck) {
      allTags.push({
        devType: 'tradeEligible',
        devValue: filterTradeEligible,
      });
    }
    if (notEligibleCheck) {
      allTags.push({
        devType: 'tradeInEligible',
        devValue: filterTradeInEligible,
      });
    }
    if (mroCheck) {
      allTags.push({
        devType: 'mroCheck',
        devValue: filterMRO,
      });
    }
    return (
      allTags.map((tag, index) => (
        <div className="tag-box" key={`tag${index + 1}`}>
          <Tag
            label={tag.devValue}
            icon="icon-navigation-close"
            iconPosition="right"
            id={`${tag.devType}|${tag.devValue}`}
            onCloseClick={onTagClose}
          />
        </div>
      ))
    );
  };

  const applyCancel = () => {
    setCurrentDeviceSearchSelected([]);
    setNewDeviceSearchSelected([]);
    setFiveGCheck(false);
    setNonFiveGCheck(false);
    setEligibleCheck(false);
    setNotEligibleCheck(false);
    setMroCheck(false);
    cancelFilter();
  };

  return (
    <div className="device-filter-section">
      {filterOpen === false && filterApplied &&
        <div className="row">
          {generateFilterTags()}
        </div>
      }
      {filterOpen &&
        <React.Fragment>
          <div className="row">
            <div className="col-12 heading20">
              {filterHeading}
            </div>
          </div>
          <div className="row">
            <div className="col-6">
              <Dropdown
                dropdownId="filter-current-device-dd"
                label={filterCurrentDeviceText}
                values={currentDeviceSearchSelected}
                searchOnChange={e => searchPlanBox(e, currentDevicesList, setCurrentDeviceSearch)}
                searchBox
                highlightSelected
                multiSelection
                removeFilterSelection={removeFilterSelectionCurrentDevice}
                options={currentDeviceSearch}
                onOptionClick={selectCurrentDeviceSearchOption}
                assistiveText={filterCurrentDeviceBelowText}
              />
            </div>
            <div className="col-6">
              <Dropdown
                dropdownId="filter-new-device-dd"
                label={filterNewDeviceText}
                values={newDeviceSearchSelected}
                searchOnChange={e => searchPlanBox(e, tradeIphoneDropDownOptions, setNewDeviceSearch)}
                multiSelection
                removeFilterSelection={removeFilterSelectionNewDevice}
                searchBox
                highlightSelected
                options={newDeviceSearch}
                onOptionClick={selectNewDeviceSearchOption}
                assistiveText={filterNewDeviceBelowText}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-6">
              <div className="row">
                <div className="col-12 heading16">
                  {filterServiceHeading}
                </div>
                <div className="col-6">
                  <Checkbox
                    id="filter-5g-checkbox"
                    onChange={changeCheckbox}
                    checked={fiveGCheck}
                    label={filter5G}
                  />
                </div>
                <div className="col-6">
                  <Checkbox
                    id="filter-non-5g-checkbox"
                    onChange={changeCheckbox}
                    checked={nonFiveGCheck}
                    label={filterNon5G}
                  />
                </div>

              </div>
            </div>
            <div className="col-6">
              <div className="row">
                <div className="col-12 heading16">
                  {filterTradeInHeading}
                </div>
                <div className="col-6">
                  <Checkbox
                    id="filter-tradein-eligible-checkbox"
                    onChange={changeCheckbox}
                    checked={eligibleCheck}
                    label={filterTradeEligible}
                  />
                </div>
                <div className="col-6">
                  <Checkbox
                    id="filter-tradein-not-eligible-checkbox"
                    onChange={changeCheckbox}
                    checked={notEligibleCheck}
                    label={filterTradeInEligible}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-6">
              <div className="row mro-filter">
                <div className="col-12 heading16">
                  {filterMROHeading}
                </div>
                <div className="col-6">
                  <Checkbox
                    id="filter-mro-checkbox"
                    onChange={changeCheckbox}
                    checked={mroCheck}
                    label={filterMRO}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="row buttons-row">
            <div className="col-2 offset-8 filter-buttons">
              <Button
                variant="secondary"
                size="small"
                onClick={() => applyCancel()}
              >{filterCancel}
              </Button>
            </div>
            <div className="col-2 filter-buttons">
              <Button
                variant="primary"
                size="small"
                state="app"
                onClick={() => applyFilterSelected()}
              >{filterApply}
              </Button>
            </div>
          </div>
        </React.Fragment>
      }
    </div>
  );
};

export default DeviceFilters;
